import { render, staticRenderFns } from "./CustomerOrdersAdd.vue?vue&type=template&id=35a94881&"
import script from "./CustomerOrdersAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports